import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppServiceService } from 'src/app/api/app-service.service';
import { StorageService } from '../../core/storage.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-past-order',
  templateUrl: './past-order.page.html',
  styleUrls: ['./past-order.page.scss'],
})
export class PastOrderPage implements OnInit {
  @Output() onOrderSelect: EventEmitter<any> = new EventEmitter();

  public customerDetails = {
    customer_id: '',
  };
  
  public pastOderList: any;
  public langMsg: any;
  public order_type: string;
  public segmentValue: string = 'orders';

  constructor(public appService: AppServiceService, public storage: StorageService,private route: ActivatedRoute,
    public translate: TranslateService, private router: Router) { }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      if (params && params.cancelSuscess) {
        this.getOrderDetails();
      }
    });
  }

  // ionViewWillEnter(){
  //   this.appService.appObject.isLoading = true;
  //   this.getLang();
  //   setTimeout(() => {
  //     this.getCustomer();
  //   }, 500);

  // }

  ngAfterViewInit() {
    setTimeout(() => {
      this.appService.appObject.isLoading = true;
    }, 10);
    this.getLang();
    setTimeout(() => {
      this.getCustomer();
    }, 500);
  }

  async getLang() {
    this.translate.get('key').subscribe(
      value => {
        this.langMsg = value;
      }
    )
  }

  getCustomer() {

    this.customerDetails.customer_id = this.appService.appObject.userId;
    this.getOrderDetails();
  }

  getOrderDetails() {
    this.pastOderList = [];
    // this.appService.showAlert('success','Customer ID' , this.appService.appObject.userId, false);
    this.appService.customerOrderList(this.customerDetails,this.segmentValue).then(response => {
      if (response.status) {
        this.pastOderList = response.data;
        console.log('pastOderList',this.pastOderList);
      }
      this.appService.appObject.isLoading = false;
    }, error => {
      this.appService.appObject.isLoading = false;
    });
  }

  setDateTime(datetime,orders) {
    var month = new Date(datetime).getMonth();
    month++;
    var day = new Date(datetime).getDate();
    var year = new Date(datetime).getFullYear();
    var hours: any = new Date(datetime).getHours();
    var minutes: any = new Date(datetime).getMinutes();
    if (hours < 10) {
      hours = '0' + hours;
    }
    if (minutes < 10) {
      minutes = '0' + minutes
    }
    if (orders === 'special') {
      return year + '/' + month + '/' + day;
    } else {
      return year + '/' + month + '/' + day + ' ' + hours + ':' + minutes;
    }
  }

  orderDeliveryType(order_delivery_type) {
    if (order_delivery_type === 'pickup') {
      return this.langMsg.pickup;
    }
    else if (order_delivery_type === 'delivery') {
      return this.langMsg.delivery;
    }
    else if (order_delivery_type === 'dine_in') {
      return this.langMsg.dine_in;
    }
  }

  orderStatus(status) {
    if (status === 'processing') {
      return this.langMsg.processing;
    } else if (status === 'accepted') {
      return this.langMsg.accepted;
    } else if (status === 'cancelled') {
      return this.langMsg.cancelled;
    } else if (status === 'paid') {
      return this.langMsg.paid;
    } else if (status === 'rejected') {
      return this.langMsg.rejected;
    } else if (status === 'completed') {
      return this.langMsg.completed;
    } else if (status === 'delivering') {
      return this.langMsg.delivering;
    }
  }

  /**
   * 
   * @param order 
   */
  navigateToOrderDetail(order) {
    if (this.appService.isWebVersion) this.onOrderSelect.emit([order.payment_id, order.order_delivery_type, 'general']);
    else this.router.navigate(['order-summery', order.payment_id]);
  }

  navigateTosubScriptionDetail(subscription){
    if (this.appService.isWebVersion) this.onOrderSelect.emit([subscription.id, subscription.order_delivery_type, 'subscription']);
    else {
      if (subscription.order_type === 'general_special') {
        this.router.navigate(['special', subscription.id]);
      } else {
        this.router.navigate(['subscription-summery', subscription.id]);
      }
    }
  }

  orderPaymentType(order_payment_type) {
    if (order_payment_type === 'cod') {
      return this.langMsg.cod;
    } else if (order_payment_type === 'paypal') {
      return this.langMsg.paypal;
    }
  }

  jsonDec(j,type){
    if (j && type != 'daily') {
      return JSON.parse(j);
    }
  }

  segmentChanged(e){
    this.getOrderDetails();
  }

}
